import { Injectable, OnDestroy } from '@angular/core';
import { Observable, Subject, takeUntil } from 'rxjs';
import { HttpClient, HttpParams } from '@angular/common/http';
import { TranslateService } from './translate.service';
import { environment } from '../../environments/environment';
import { IProperty } from '../models/property/property.interface';
import { PropertyEditDto } from '../models/property/propertyEditDto.interface';

@Injectable({
  providedIn: 'root',
})
export class PropertyService implements OnDestroy {
  isTranslator: boolean | undefined;

  private _destroy$ = new Subject<void>();

  constructor(
    private http: HttpClient,
  ) {
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  private getHostUrl = () => {
    const url = environment.scheme + environment.host + environment.port + '/';
    return url;
  };

  private readonly createPropertyUrl = `${this.getHostUrl()}api/v${
    environment.version
  }/Property/create`;

  private readonly updatePropertyUrl = `${this.getHostUrl()}api/v${
    environment.version
  }/Property/update`;
  private readonly deletePropertyUrl = `${this.getHostUrl()}api/v${
    environment.version
  }/Property/delete`;

  private readonly getDestinationsListUrl = `${this.getHostUrl()}api/v${
    environment.version
  }/Property/getDestinationList`;

  private readonly getPropertyUrl = `${this.getHostUrl()}api/v${
    environment.version
  }/Property/getByCrmPropertyId`;

  updateProperty(property: PropertyEditDto): Observable<any> {
    return this.http.put<any>(this.updatePropertyUrl, property);
  }

  getDestinationsList(): Observable<any> {
    return this.http.get<any>(this.getDestinationsListUrl);
  }

  getProperty(crmPropertyId: string): Observable<any> {
    let params = new HttpParams().set('crmPropertyId', crmPropertyId);
    return this.http.get<any>(this.getPropertyUrl, {params});
  }
}
